import { render, staticRenderFns } from "./user_auth_detail.vue?vue&type=template&id=720d2443&scoped=true"
import script from "./user_auth_detail.vue?vue&type=script&lang=js"
export * from "./user_auth_detail.vue?vue&type=script&lang=js"
import style0 from "./user_auth_detail.vue?vue&type=style&index=0&id=720d2443&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720d2443",
  null
  
)

export default component.exports